import type {FunctionComponent} from 'preact';
import {useMemo} from 'preact/hooks';

import {useRootProvider} from '../RootProvider/hooks';

import {Bugsnag} from './Bugsnag';
import {BugsnagContext} from './context';
import type {BugsnagProviderProps} from './types';

export const BugsnagProvider: FunctionComponent<BugsnagProviderProps> = ({
  children,
}) => {
  const {featureName: feature} = useRootProvider();

  const value = useMemo(() => {
    if (!feature) {
      // eslint-disable-next-line no-process-env
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('BugsnagProvider created without a feature name.');
      }
    }

    const {client, leaveBreadcrumb, notify} = new Bugsnag(feature);

    return {
      client,
      leaveBreadcrumb,
      notify,
    };
  }, [feature]);

  return (
    <BugsnagContext.Provider value={value}>{children}</BugsnagContext.Provider>
  );
};
